import React, { useEffect } from "react";
import logo from "../Assets/Logo/logo.webp";

const Apply = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.fbq) {
      window.fbq("track", "Lead");
    }
  }, []);

  return (
    <>
      <section>
        <div className="container">
          <div className="mt-5">
            <div className="alignment">
              <img src={logo} alt="Social Eagle" className="calenderlogo" />
            </div>

            <div className="mt-5">
              <iframe
                src="https://orufybookings.com/social-eagle-private-limited/expert-call-with-social-eagle-digital-marketing"
                width="100%"
                height="1000"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Booking Calendar"
              ></iframe>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Apply;